import axiosService from '@app/services/axiosService';
import { API_SC_GATEWAY_ENDPOINT } from '@app/constants/api';
import { ApiGatewayDataPost } from '@app/models/common/apiGatewayDataPost.model';

const TRANSIT_STATION_URL = `${API_SC_GATEWAY_ENDPOINT}/v1/ScGateway/TransitStation/ToolDichVu`;

const globalGatewayApis = {
    doTransit(dataPost: ApiGatewayDataPost) {
        return axiosService.post(TRANSIT_STATION_URL, dataPost);
    },
};

export default globalGatewayApis;
